<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Crear Pedido</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div v-if="isDataLoaded" class="col-lg-6 col-5 text-right">
          <router-link
            v-if="$can('show', 'orders')"
            :to="{ name: 'OrderShow', params: { id: orderId } }"
            class="btn base-button btn-neutral text-primary bg-white btn-sm"
          >
            Ver detalle
          </router-link>
        </div>
      </div>
    </base-header>

    <div v-if="isDataLoaded" class="container-fluid mt--6">
      <div class="row justify-content-center">
        <same-variety-correction-form
          v-if="canCreate"
          ref="sourceFirstCorrection"
          :order-id="orderId"
          :order-state="order.state ? order.state.name : null"
          @correction-mode="setCorrectionMode"
          @corrected="refreshCorrectedOrder"
        />

        <order-form
          v-if="canCreate && showGenericOrderForm"
          ref="orderForm"
          :campaign="campaign"
          :order="order"
          :projection="order.projection"
          :order-id="orderId"
          :producer="producer"
          :stock-source-editing-controlled="['restricted', 'source-first'].includes(correctionMode)"
          title="Editar Pedido"
          @confirm="confirmOrder"
          @items-changed="refreshCorrectionContext"
          @save="updateOrder"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import OrderForm from './Forms/OrderForm';
import SameVarietyCorrectionForm from './Forms/SameVarietyCorrectionForm';
import swal from 'sweetalert2';
import { shouldShowGenericOrderForm } from '@/util/orderControlledCorrection';

export default {
  name: 'OrdersEdit',
  components: {
    RouteBreadCrumb,
    OrderForm,
    SameVarietyCorrectionForm,
  },

  data() {
    return {
      isDataLoaded: false,
      campaign: null,
      producer: null,
      orderId: 0,
      order: null,
      correctionMode: 'loading',
    };
  },

  computed: {
    canCreate() {
      return this.campaign && this.producer;
    },

    showGenericOrderForm() {
      const state = this.order && this.order.state ? this.order.state.name : null;
      return shouldShowGenericOrderForm(state, this.correctionMode);
    },
  },

  mounted() {
    let id = +this.$route.params.id;
    if (id) {
      this.orderId = id;
      this.fetchOrder();
    } else {
      this.$router.push({ name: 'OrdersList' });
    }
  },

  methods: {
    fetchOrder() {
      const params = {
        include: [
          'producer.distributor.seller',
          'campaign.articles',
          'state',
          'items.article',
          'projection',
          'dollarQuotation',
        ],
      };

      return this.$services
        .resource('orders')
        .show(this.orderId, params)
        .then((res) => res.data.data)
        .then((order) => {
          this.order = order;
          this.campaign = order.campaign;
          this.producer = order.producer;
          this.isDataLoaded = true;

          return order;
        });
    },

    async updateOrder(order, saveLifecycle) {
      try {
        await this.$services.resource('orders').update(this.orderId, order);

        // The update response is not guaranteed to contain the relationships
        // used by the editor. Refetch the saved order so items and stockSource
        // both come from the persisted model before opening the item step.
        const persistedOrder = await this.fetchOrder();
        await this.refreshCorrectionContext();
        saveLifecycle.resolve(persistedOrder);
      } catch (errors) {
        // Keep the current component (and its inline item drafts) mounted. In
        // particular, a rejected source conversion must show the backend stock
        // reason without replacing the form with a fresh copy of the order.
        saveLifecycle.reject(errors);
      }
    },

    async refreshCorrectedOrder() {
      const persistedOrder = await this.fetchOrder();
      await this.$nextTick();

      if (this.$refs.orderForm) {
        this.$refs.orderForm.syncControlledCorrection(persistedOrder);
      }
    },

    async refreshCorrectionContext() {
      if (this.$refs.sourceFirstCorrection) {
        await this.$refs.sourceFirstCorrection.fetchContext(false);
      }
    },

    setCorrectionMode(mode) {
      this.correctionMode = mode;
    },

    confirmOrder() {
      // redirigir al resumen de pedido
      this.$services
        .resource('orders')
        .confirm(this.orderId)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'El pedido fue confirmado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'OrderShow', params: { id: this.orderId } }));
        })
        .catch((errors) => {
          // this.serverErrors = errors
        });
    },
  },
};
</script>
